import { render } from "./icon-tab.vue?vue&type=template&id=3a578d2d&scoped=true"
import script from "./icon-tab.vue?vue&type=script&lang=js"
export * from "./icon-tab.vue?vue&type=script&lang=js"

import "./icon-tab.vue?vue&type=style&index=0&id=3a578d2d&scoped=true&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a578d2d"]])

export default __exports__